module.exports = __webpack_public_path__ + "static/media/tech-docs-preview.031a1b68.png";